/*
 *   File : update-rm.js
 *   Author URI : https://evoqins.com
 *   Description :  To link a customer account against a Relationship Manager.
 *   Integrations : null
 *   Version : v1.1
 */


import { useEffect, useState } from "react";


import { Icon } from "../Icon";
import { GradientButton, OutlineButton } from "../Cta";
import { closeModal } from "../../Helper/helper-function";

import style from "../../Styles/Components/update-rm.module.scss";
import WhiteLabelPreviewModal from "./white-label-preview";
import { CustomLoader } from "../Other";

const PreviewModal = (props) => {

    const [loader, setLoader] = useState(true);

    useEffect(() => {
        const my_modal = document.getElementById("preview-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleClose();
        });
    }, []);


    useEffect(() => {
        if (props.previewImage !== null &&
            props.headerLogoIcon !== null &&
            props.headerLogoText !== null &&
            props.footerLogoIcon !== null &&
            props.footerLogoText !== null &&
            props.footerText !== null) {
            setLoader(false);
        }
    }, [props.previewImage, props.headerLogoIcon, props.headerLogoText, props.footerLogoIcon, props.footerLogoText, props.footerText]);



    const _handleBack = () => {
        props.handleClose();
    };


    const _handleContinue = () => {
        closeModal("preview-modal");
        props.handleContinue();
    };

    return (
        <div className={`modal fade ${style.e_update_rm}`}
            id="preview-modal"
            tabIndex="-1"
            aria-labelledby="preview-modal"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered modal-dialog-scrollable ${style.e_dialog}`}>
                <div className={`modal-content  bg-white padding-32px-all ${style.e_content} `}>

                    <div className="modal-header p-0 d-flex justify-content-between align-items-center mb-3 border-0">
                        <p className="e-poppins-medium e-font-18 line-height-16px mb-0">Preview</p>
                        <Icon icon="close"
                            size={24}
                            data-bs-dismiss="modal"
                            className="cursor-pointer e-modal-close-btn" />
                    </div>

                    <div className="modal-body p-0">
                        {loader ?
                            <CustomLoader />
                            :
                            <WhiteLabelPreviewModal
                                previewImage={props.previewImage}
                                headerLogoText={props.headerLogoText}
                                headerLogoIcon={props.headerLogoIcon}
                                footerLogoText={props.footerLogoText}
                                footerLogoIcon={props.footerLogoIcon}
                                footerText={props.footerText} />
                        }
                    </div>


                    <div>
                        <div className="modal-footer border-0 d-flex justify-content-end gap-3 px-0 pb-0">
                            <OutlineButton label="Back"
                                cancel="modal"
                                className="padding-12px-tb padding-44px-lr white-space-nowrap bg-white e-font-16 e-poppins-regular "
                                handleClick={_handleBack} />
                            <GradientButton label="Continue"
                                className="padding-12px-tb e-font-16  "
                                loading={props.btnLoader}
                                onPress={_handleContinue} />
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default PreviewModal;